export default __webpack_public_path__ + "static/tooltip-info-do-dark-e2fc846f53c6bd03e8de980037cc46c1.png";